<template>
  <v-navigation-drawer
    app
    width="220"
    v-model="drawer"
    @input="$emit('input', drawer)"
    :permanent="!isTemporary"
    v-if="isAuth"
    :temporary="isTemporary"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="title"> EL CHEAPO </v-list-item-title>
        <v-list-item-subtitle> Jobs Management System </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list dense nav tile>
      <!-- ✅ FIXED: Removed :key from template, added to real elements -->
      <template v-for="(item, i) in items" >
        <v-list-item
          :key="`item-${i}`"
          :class="active(item)"
          link
          @click="open(item)"
        >
          <v-list-item-content>
            <v-list-item-title class="subtitle-2" :class="active(item)">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        
        <v-divider 
          v-if="item.addDivider" 
          :key="`divider-${i}`"
          class="my-2"
        ></v-divider>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { auth } from "../assets/js/firebase";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isAuth: false,
      drawer: false,
      items: [
        {
          title: "Estimate",
          path: "/estimate/create",
        },
        {
          title: "Manage Estimate",
          path: "/manage-estimate",
          addDivider: true, 
        },
        {
          title: "Manage Potential Customers",
          path: "/",
        },
        {
          title: "Manage Jobs",
          path: "/jobs",
        },
        {
          title: "Manage Templates",
          path: "/templates",
          addDivider: true, 
        },
        {
          title: "Search Engine",
          path: "/search-engine",
        },
        {
          title: "Dispatch Sheet",
          path: "/dispatch-sheet",
        },
        {
          title: "SMS Templates",
          path: "/sms-templates",
          addDivider: true,
        },
        {
          title: "Car Make Model / Applications",
          path: "/car-make",
        },
        {
          title: "Car Make Model / Car Unlocking",
          path: "/car-make-unlocking",
        },
        {
          title: "Mechanical Key",
          path: "/mechanical-key",
        },
        {
          title: "Insert Blade",
          path: "/insert-blade",
          addDivider: true,
        },
        {
          title: "Zip Codes",
          path: "/zip-codes",
        },
        {
          title: "CMP",
          path: "/cmp",
        },
        {
          title: "Manage Technicians",
          path: "/technicians",
        },
        {
          title: "Manage Fields",
          path: "/fields",
        },
        {
          title: "Manage Dispatchers",
          path: "/users",
          addDivider: true, 
        },
        {
          title: "Customer SMS",
          path: "/sms",
        },
        {
          title: "Technician SMS",
          path: "/technician-sms",
        },
        {
          title: "Quick Look Up",
          path: "/quick-look-up",
          addDivider: true, 
        },
        {
          title: "Customer Emails",
          path: "/customer-emails",
        },
        {
          title: "Key Logs",
          path: "/key-logs",
        },
        {
          title: "Error Logs",
          path: "/error-logs",
        },
        {
          title: "Logout",
          path: "logout",
        },
      ],
    };
  },
  watch: {
    value(val) {
      this.drawer = val;
    },
  },
  computed: {
    isTemporary() {
      return window.innerWidth < 1200;
    },
  },
  methods: {
    active({ path }) {
      return this.$route.path === path ? "primary white--text" : "";
    },
    open({ path }) {
      if (path === "logout") {
        auth.signOut();
        return;
      }
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
  },
  mounted() {
    const vm = this;
    auth.onAuthStateChanged((user) => {
      vm.isAuth = user !== null;
    });
  },
};
</script>

<style lang="scss">
.list-active {
  background: #1976d229;
  .v-list-item__title {
    color: #1976d2 !important;
  }
}

.v-navigation-drawer .v-list .v-divider {
  border-top: 1.2px solid rgba(0, 0, 0, 1) !important;
  margin: 10px 0 !important;
  opacity: 1 !important;
}
</style>
